export default __webpack_public_path__ + "static/media/lipin.8d37fe38.png";